import { type PropsWithChildren } from 'react';

import { XYChartVisibleAxesScalesContext } from '../context/axes/XYChartVisibleAxesScales.context.js';
import { useVisibleAxesConfig } from '../hooks/useVisibleAxesConfig.js';
import { useXYChartScales } from '../hooks/useXYChartScales.js';
import type { XYChartVisibleAxesScales } from '../types/xy-chart-internals.js';
import { getCurrentScale } from '../utils/get-scale.js';

export function XYChartVisibleAxesScalesProvider({
  children,
}: PropsWithChildren) {
  const axisIdToScales = useXYChartScales();
  const { top, bottom, left, right } = useVisibleAxesConfig();

  const scales: XYChartVisibleAxesScales = {
    top: top ? getCurrentScale(axisIdToScales, top.id) : undefined,
    bottom: bottom ? getCurrentScale(axisIdToScales, bottom.id) : undefined,
    left: left ? getCurrentScale(axisIdToScales, left.id) : undefined,
    right: right ? getCurrentScale(axisIdToScales, right.id) : undefined,
  };

  return (
    <XYChartVisibleAxesScalesContext.Provider value={scales}>
      {children}
    </XYChartVisibleAxesScalesContext.Provider>
  );
}
